import { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full px-4 py-3.5 rounded-xl bg-white/10 border border-white/20 text-white placeholder-slate-400 text-base focus:outline-none focus:ring-2 focus:ring-[#C5A059]";

export default function CadastroParceiro() {
  const [form, setForm] = useState({ name: '', responsible_name: '', whatsapp: '', email: '', cnpj: '', company_type: 'MEI', postal_code: '', address_number: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await axios.post(`${API}/partner-signup`, form);
      setDone(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao cadastrar. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A2647] flex flex-col items-center p-5 py-10" data-testid="cadastro-parceiro-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <p className="text-4xl mb-2">🤝</p>
          <h1 className="text-3xl font-bold text-[#C5A059]">Seja um Parceiro Oficial</h1>
          <p className="text-slate-300 text-sm mt-2">Falo com o Dono · Programa de Parceria</p>
        </div>

        {!done ? (
          <>
            <div className="bg-white/10 border border-[#C5A059]/40 rounded-2xl p-5 mb-5 space-y-2">
              {[
                ['💰', <span key="1"><b className="text-white">20% de comissão recorrente</b> — todo mês, de todo cliente seu, direto na sua conta Asaas</span>],
                ['⚡', <span key="2">Painel com <b className="text-white">Cadastro Relâmpago</b>: 3 campos e o cliente sai ativo na hora</span>],
                ['🔗', <span key="3">Seu <b className="text-white">Link Relâmpago + QR Code</b>: o cliente se cadastra sozinho e a venda é sua</span>],
                ['👥', <span key="4">Monte sua <b className="text-white">carteira de afiliados</b>: cadastre afiliados e multiplique sua rede</span>],
              ].map(([icon, text], i) => (
                <p key={i} className="text-xs text-slate-300 leading-relaxed flex gap-2"><span>{icon}</span><span>{text}</span></p>
              ))}
            </div>

            <form onSubmit={submit} className="space-y-3" data-testid="parceiro-form">
              <input required placeholder="Nome da sua empresa" value={form.name} onChange={set('name')} className={inputCls} data-testid="parceiro-empresa" />
              <input required placeholder="Seu nome (responsável)" value={form.responsible_name} onChange={set('responsible_name')} className={inputCls} data-testid="parceiro-responsavel" />
              <input required placeholder="Seu WhatsApp (com DDD)" inputMode="tel" value={form.whatsapp} onChange={set('whatsapp')} className={inputCls} data-testid="parceiro-whatsapp" />
              <input required type="email" placeholder="Seu e-mail" value={form.email} onChange={set('email')} className={inputCls} data-testid="parceiro-email" />
              <input required placeholder="CNPJ (ou CPF se autônomo)" inputMode="numeric" value={form.cnpj} onChange={set('cnpj')} className={inputCls} data-testid="parceiro-cnpj" />
              <div className="grid grid-cols-2 gap-3">
                <input required placeholder="CEP" inputMode="numeric" value={form.postal_code} onChange={set('postal_code')} className={inputCls} data-testid="parceiro-cep" />
                <input placeholder="Nº do endereço" inputMode="numeric" value={form.address_number} onChange={set('address_number')} className={inputCls} data-testid="parceiro-numero" />
              </div>
              <select value={form.company_type} onChange={set('company_type')} className={`${inputCls} appearance-none`} data-testid="parceiro-tipo">
                <option value="MEI" className="text-slate-900">MEI</option>
                <option value="LIMITED" className="text-slate-900">Empresa LTDA</option>
                <option value="INDIVIDUAL" className="text-slate-900">Autônomo (CPF)</option>
                <option value="ASSOCIATION" className="text-slate-900">Associação</option>
              </select>
              {error && <p className="text-red-400 text-sm text-center" data-testid="parceiro-error">{error}</p>}
              <button type="submit" disabled={loading} data-testid="parceiro-submit"
                className="w-full bg-[#C5A059] text-[#0A2647] font-bold text-lg py-4 rounded-xl hover:bg-[#b8934d] transition-colors disabled:opacity-60">
                {loading ? 'Ativando sua parceria...' : 'Ativar minha parceria agora 🚀'}
              </button>
              <p className="text-slate-400 text-xs text-center">Ativação imediata · Sem mensalidade · Você recebe o kit completo no WhatsApp</p>
            </form>
          </>
        ) : (
          <div className="bg-white/10 border border-[#C5A059]/40 rounded-2xl p-8 text-center" data-testid="parceiro-success">
            <p className="text-5xl mb-4">🎉</p>
            <h2 className="text-xl font-bold text-white mb-2">Parceria ativada!</h2>
            <p className="text-slate-300 text-sm leading-relaxed mb-4">
              Enviamos seu <b className="text-[#C5A059]">kit de boas-vindas no WhatsApp</b> com o passo a passo
              para vender e montar sua carteira. Seu painel exclusivo:
            </p>
            <a href={done.panel_url} data-testid="parceiro-painel-link"
              className="inline-block bg-[#C5A059] text-[#0A2647] font-bold px-6 py-3 rounded-xl">Abrir meu painel</a>
          </div>
        )}
      </div>
    </div>
  );
}
